// Base URL
const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:6060/"
    : "https://nodeapi.envimap.hu/"

// Routes
const mailchimp = `${baseURL}mc/`

// Used urls in API calls
export const urls = {
  // Mailchimp
  mcSubscribe: `${mailchimp}subscribe`, // Subscribe
  mcUnsubscribe: `${mailchimp}unsubscribe`, // Unsubscribe
  mcMemberInfo: `${mailchimp}memberinfo`, // Get member information

  // VAT number validator
  vatNum: "https://api.cegjelzo.com/api/v2/search", // Production
}
